import React from 'react';

import ErrorBoundary from '../ErrorBoundary';
import './Dashboard.css';

function MainView(props) {
  const { children, description, heading, interactive, title } = props;
  if (interactive) {
    document.title = title;
  }
  return (
    <main id="details">
      <h2>{heading}</h2>
      <p>{description}</p>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </main>
  );
}

export default MainView;
